// @flow
import React from 'react';
import { Dropdown, Icon } from '@elements';
import { withTranslation } from 'react-i18next';
import { createNsTranslator, isShareable, isCordovaApp, isPdfFile, UserNotifications } from '@helpers/helpers';

type Props = {
    file: Object,
    onSelectFileAction: Function,
    fileAttachmentDropdownList: any,
    // Opens the PDF viewer on this file
    onOpenPDF?: (file: Object) => void,
    t: Function,
}

class FileAttachment extends React.Component<Props> {
  render() {
    const { file, onOpenPDF, fileAttachmentDropdownList } = this.props;

    const _ = createNsTranslator('timeline', this.props.t);

    const dropdownItems = [
      { text: _('action/download'), href: file.downloadUrl, target: '_blank', download: file.name, noClick: true },
      ...fileAttachmentDropdownList,
    ];

    // A PDF opens with a tap on its name, on every platform; its other actions are behind ⋮
    if (onOpenPDF && isPdfFile(file)) {
      return (
        <div className="fileAttachment isPDF">
          <button type="button" className="fileAttachmentOpen" onClick={this.handleOpen}>
            <Icon iconName='file-solid' className='documentIcon icon' size={18} />
            <span className='fileAttachmentText'>{file.name}</span>
          </button>
          <Dropdown
            mobileLabel={file.name}
            className="fileAttachmentMenu"
            icon="dots-vertical"
            disableArrowIcon
            items={dropdownItems}
            onSelectItem={this.handleSelectFileAction}
          />
        </div>
      );
    }

    return (
      <div className="fileAttachment">
        <button type="button">
          <Icon iconName='file-solid' className='documentIcon icon' size={18} />
          <span className='fileAttachmentText'>{file.name}</span>
        </button>

        <Dropdown
          mobileLabel={file.name}
          className="fullWidth"
          items={dropdownItems}
          onSelectItem={this.handleSelectFileAction}
        />
      </div>
    );
  }

  handleOpen = () => {
    const { file, onOpenPDF } = this.props;
    if (onOpenPDF) onOpenPDF(file);
  };

  handleSelectFileAction = (item: any) => {
    const { file, onSelectFileAction } = this.props;
    if (item.action === 'download' && !isShareable(file.name) && isCordovaApp()) {
      UserNotifications.i18nTextAlert('error/mobile/file_not_downloadable');
    } else {
      onSelectFileAction(file)(item);
    }
  };
}
export default withTranslation()(FileAttachment);
